import { useTranslation } from 'react-i18next';
import {
  Change,
  ChangeType,
  ContactChangeType,
} from '../../../modules/dashboard/models/dashboard.types';

export const useDashboard = () => {
  const { t } = useTranslation();
  const getChangeType = (change: Change) => {
    if (change.contact) {
      return {
        change_type: ChangeType.Contact,
        change_type_detail: change.contact?.change_type,
        sender_avatar: change.contact?.user_1_avatar,
      };
    } else if (change.room) {
      return {
        change_type: ChangeType.Room,
        change_type_detail: change.room?.change_type,
        sender_avatar: change.room?.user_1_avatar,
      };
    } else if (change.template) {
      return {
        change_type: ChangeType.Template,
        change_type_detail: change.template?.change_type,
        sender_avatar: change.template?.user_1_avatar,
      };
    } else if (change.tool) {
      return {
        change_type: ChangeType.Tool,
        change_type_detail: change.tool?.change_type,
        sender_avatar: change.tool?.user_1_avatar,
        change_content: '',
      };
    }
  };
  return { getChangeType };
};
